import { useDispatch } from "react-redux"
import { AnyAction } from "redux"
import { ThunkDispatch } from "redux-thunk"
import { StoreState } from "../store/StoreState"

export type ReduxDispatch = ThunkDispatch<StoreState, any, AnyAction>
export function useReduxDispatch() {
    return useDispatch<ReduxDispatch>()
}
